// extracted by mini-css-extract-plugin
export default {"leaderboardPage":"styles_leaderboardPage__gVtgP"};